import React from 'react';

interface PageHeadingProps {
  title: string;
  className?: string;
}

const PageHeading: React.FC<PageHeadingProps> = ({ title, className = 'text-black' }) => (
  <div
    style={{ background: 'linear-gradient(#fec733, #fbac40)' }}
    className={`font-semibold px-0.5 md:px-3 py-1.5 text-[12px] md:text-[14px] ${className}`}
  >
    {title}
  </div>
);

export default PageHeading;
